import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './LeadersSection.css'; // Optional: For custom styles

const LeadersSection = () => {
  return (
    <div className="container py-5">

      {/* Section 1 - Director */}
      <div className="row align-items-center mb-5">
        {/* Image Left */}
        <div className="col-md-6">
          <img
            src="/img/director.jpeg"
            alt="Director"
            className="img-fluid rounded shadow"
          />
        </div>

        {/* Content Right */}
        <div className="col-md-6">
          <h2 className="mb-3">Mr. R.S Gujar</h2>
          <h5 className="text-muted mb-3"> Managing Director, Shree JRB Group</h5>
          <p>
            Mr. R.S Gujar is the visionary Managing Director of Shree JRB Group. With over 20 years of experience in the real estate industry, he has led the company to new heights. His commitment to innovation, quality, and customer satisfaction is at the heart of the company's values.
          </p>
        </div>
      </div>

      {/* Section 2 - Managing Director */}
      <div className="row align-items-center flex-md-row-reverse">
        {/* Image Right */}
        <div className="col-md-6">
          <img
            src="img/mdirector.jpeg"
            alt="Managing Director"
            className="img-fluid rounded shadow"
          />
        </div>

        {/* Content Left */}
        <div className="col-md-6">
          <h2 className="mb-3">Mr.JP Devanda </h2>
          <h5 className="text-muted mb-3"> Director, Shree JRB Group</h5>
          <p>
            As the  Director, Mr. JP Devanda brings strategic direction and operational excellence to Shree JRB Group. His leadership has strengthened the organization’s foundation and expanded its presence across multiple cities with a focus on sustainable development.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LeadersSection;
    